/** 项目模板表 */

import type { XEntity } from '@/api';
import type { ProjectInstTask } from '../task/model';

/** 全局配置项目ID */
export const GLOBAL_CONFIG_INST_ID = 'global_config';
/** 全局配置项目名称 */
export const GLOBAL_CONFIG_INST_NAME = '全局配置';

export interface ProjectInst {
  /** 主键 */
  seq?: number;
  /** 租户ID */
  tenantId?: string;
  /** 数据范围（学年） */
  dataScopeId?: number;
  /** 应用ID*/
  appId?: string;
  /**  所属大学编号 */
  universitySeq?: number;
  /**  所属大学称 */
  universityName?: string;
  /**  模板ID */
  templateId?: string;
  /**  模板名称 */
  templateName?: string;
  /**  项目Id */
  projectId?: string;
  /**  项目名称 */
  projectName?: string;
  /**  当前阶段ID */
  currentPhaseId?: string;
  /**  当前阶段名称 */
  currentPhaseName?: string;

  /**  所属学院 */
  college?: string;
  /**  所属系所 */
  department?: string;
  /**  所属教研室 */
  teaching?: string;
  /**  所属专业 */
  major?: string;
  /** 所属届次（批次） */
  graduation?: string;

  /**  关联用户ID */
  userid?: string;
  /** 关联用户名称 */
  username?: string;
  /**  项目开始日期 */
  startAt?: Date;
  /**  项目结束日期 */
  endAt?: Date;
  /**  优先级：1低、2中、3高 */
  priority?: number;
  /** 项目状态码:0未开始、1进行中、2已完成、3已终止 */
  status?: number;
  /**  项目状态码说明 */
  statusMsg?: string;
  /** 图标 */
  icon?: string;

  /** 任务 */
  tasks?: ProjectInstTask[];
}

/** 任务团队成员 */
export interface ProjectInstTaskTeam extends XEntity {
  /** 对象跟踪ID */
  trackId?: string;
  /** 答辩跟踪ID */
  trackDpId?: string;
  /** 专家评审跟踪ID */
  trackExId?: string;

  /** 所属大学编号 */
  universitySeq: number;
  /** 模板ID */
  templateId: string;
  /** 项目Id */
  projectId: string;
  roleCode: string;
  /** 关联用户ID */
  userid: string;
  /** 关联用户姓名 */
  username: string;
  /** 任务ID */
  taskId: string;

  /** 排序号 */
  sortNumber: number;
}
